import React, { useState, useEffect } from 'react'
import { ErrorPage, LoadingPage } from '@wallyhealth/web-core'
import { useFetchExperiment } from './hooks'
import { prepSubscription } from './api'
import InfoFormPage from 'pages/InfoFormPage'
import PaymentPage from 'components/PaymentPage'
import useQuery from 'hooks/useQuery'
import heapService from 'services/heapService'
import { useGeos } from 'hooks/useGeos'

const Steps = {
  FORM: 'FORM',
  PAY: 'PAY'
}

const JoinNowFlow = () => {
  const query = useQuery()
  const experimentId = query.get('eid')

  const [step, setStep] = useState(Steps.FORM)
  const [info, setInfo] = useState(null)

  const { locations } = useGeos()
  const { experiment, isLoadingExperiment, isExperimentActive } = useFetchExperiment({ externalId: experimentId })

  const scrollToTop = () => (
    window.scrollTo({ top: 0, behavior: 'smooth' })
  )
  useEffect(() => {
    scrollToTop()
  }, [step])

  const storeHeapUserProperties = () => {
    heapService.storeUserProperties({
      phone: info.phone,
      email: info.email,
      costInCents: experiment?.config?.paymentAmountInCents,
      location: resolveLocationName(),
      planType: experiment?.config?.billingPlanType,
      couponCode: null
    })
  }

  const resolveLocationName = () => {
    return locations.find(it => it.id === experiment.config.homeLocationId)?.name
  }

  const handleInfo = (info) => {
    setInfo(info)
    setStep(Steps.PAY)
  }
  const handleSubscriptionPrep = () => {
    storeHeapUserProperties()

    return prepSubscription({
      patient: info,
      planPublicId: experiment?.config?.billingPlanPublicId,
      location: locations.find(l => l.id === experiment.config.homeLocationId),
      welcomeMessageId: experiment?.config?.welcomeMessageId,
      tasks: [
        {
          taskType: 'GROWTH',
          text: `Handle ${experiment.name} booking`,
          details: `Location: ${resolveLocationName()}`
        }
      ]
    })
  }

  if (isLoadingExperiment) {
    return (
      <LoadingPage />
    )
  }

  if (!experimentId || !isExperimentActive) {
    return (
      <ErrorPage
        title="Hm..."
        description="Looks like this link has expired."
      />
    )
  }

  return (
    <div>
      {step === Steps.FORM &&
        <InfoFormPage
          onSubmit={handleInfo}
          viewName="JoinNowInfoFormPage"
        />
      }
      {step === Steps.PAY &&
        <PaymentPage
          customer={info}
          totalCostInCents={experiment?.config?.paymentAmountInCents}
          planType={experiment?.config?.billingPlanType}
          prepSubscription={handleSubscriptionPrep}
          viewName="JoinNowPaymentPage"
          title={experiment?.config?.paymentPageTitle}
          description={experiment?.config?.paymentPageDescription}
        />
      }
    </div>
  )
}

export default JoinNowFlow
